exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "._3N3f7w1ZjorFGEWw3u1gHt {\n  background: white;\n}", "",{"version":3,"sources":["Home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB","file":"Home.css","sourcesContent":[".home {\n  background: white;\n}"]}]);
// Exports
exports.locals = {
	"home": "_3N3f7w1ZjorFGEWw3u1gHt"
};